import { Link, useLocation } from 'react-router-dom';
import ROUTES from '../../routes/Routes.js';

export default function NavbarLinks({ isAuthenticated, user }) {
    const location = useLocation();

    if (!isAuthenticated || !user) return null;

    return (
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
                <Link to={ROUTES.CALCULATOR} className={`nav-link ${location.pathname === ROUTES.CALCULATOR ? 'active-link' : ''}`}> Cotizador </Link>
            </li>
            <li className="nav-item">
                <Link to={ROUTES.DESCRIPTIONS} className={`nav-link ${location.pathname === ROUTES.DESCRIPTIONS ? 'active-link' : ''}`}> Descripciones </Link>
            </li>
            {/* Enlaces exclusivos para admin */}
            {user.roleid === 1 && (
                <li className="nav-item">
                    <Link to={ROUTES.LINKROOT} className={`nav-link ${location.pathname === ROUTES.LINKROOT ? 'active-link' : ''}`}> Administración del sitio </Link>
                </li>
            )}
        </ul>
    );
}